/**
 * Shared formatting and text utility functions.
 */

export function escapeHtml(text) {
	if (!text) return '';
	return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function enhanceDocText(text, fmt) {
	if (fmt === 'html') {
		// Inline code: `code` -> <code>code</code> (process first to protect contents)
		text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
		// Bold: **text** -> <strong>text</strong>
		// Require at least 2 chars inside ** to avoid matching number patterns like **1:1**
		text = text.replace(/\*\*([^*]{2,})\*\*/g, '<strong>$1</strong>');
		// Legacy patterns (only match lines not already wrapped in tags)
		text = text.replace(/^([A-Z][A-Za-z]*(?:\s[A-Za-z0-9()\-']+)*):/gm, '<strong>$1:</strong>');
		text = text.replace(/^(Why|How|When|What|Where)( this | it | we )/gi, function (m) { return '<strong>' + m.trim() + '</strong>'; });
	} else {
		// Markdown export: do NOT inject bold. JSOND Rule 13 says body is plain text.
		// Structure comes from node hierarchy and format field, not inline markup.
	}
	return text;
}

export function autoLinkUrls(text) {
	return text.replace(/(https?:\/\/[^\s<>"]+)/g, '<a href="$1" class="research-citation" target="_blank" rel="noopener">$1</a>');
}

export function formatFileSize(bytes) {
	if (!bytes || bytes < 1024) return bytes + ' B';
	if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB';
	return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}
